import type { CreateOrderRequestBody } from '@paypal/paypal-js';

import type { CartSummarySectionConfig } from './types';
import { CartSummarySection } from './types';

interface IMap<K, V> extends Map<K, V> {
  get(key: K): V;
}

export enum CartSummaryEventName {
  Click = 'cart-summary_click',
  View = 'cart-summary_view',
}

export enum CartSummaryEventInteraction {
  ApplyGiftCard = 'apply_gift_card',
  ApplyVoucher = 'apply_voucher',
  RemoveVoucher = 'remove_voucher',
  Close = 'close',
}

export enum CartSummaryEventElement {
  Button = 'button',
  Link = 'link',
  PaypalExpressModal = 'PayPal modal',
  PaypalPayLaterModal = 'PayPal Pay Later modal',
}

export const SECTION_CONFIG = new Map([
  [
    CartSummarySection.Discount,
    {
      identifier: 'discount',
      iconName: 'discount',
      sectionTogglerId: 'cart-summary-voucher-button-label',
      sectionContentId: 'cart-summary-voucher-section-content',
    },
  ],
  [
    CartSummarySection.GiftCards,
    {
      identifier: 'giftcards',
      iconName: 'giftCard',
      sectionTogglerId: 'cart-summary-giftcards-button-label',
      sectionContentId: 'cart-summary-giftcards-section-content',
    },
  ],
]) as IMap<CartSummarySection, CartSummarySectionConfig>;

export const PAYPAL_EXPRESS_FUNDING_SOURCE = 'paypal';
export const PAYPAL_PAYLATER_FUNDING_SOURCE = 'paylater';
export const PAYPAL_BUTTON_STYLE = {
  color: 'white' as const,
  label: 'pay' as const,
  height: 40,
  tagline: false,
  disableMaxWidth: true,
};
export const PAYPAL_APPLICATION_CONTEXT = {
  brand_name: 'Home24 SE',
  landing_page: 'BILLING',
  shipping_preference: 'GET_FROM_FILE',
  user_action: 'CONTINUE',
} as CreateOrderRequestBody['application_context'];

export const APPLE_PAY_KNOWN_ERRORS = {
  ON_CANCEL_ERROR: 'The object does not support the operation or argument',
  ON_BEGIN_ERROR: 'Page already has an active payment session',
};

export const BUTTON_HEIGHT = 48;

export const ADYEN_PAYPAL_CONFIG = {
  isExpress: true,
  intent: 'authorize' as const,
  userAction: 'continue' as const,
  style: PAYPAL_BUTTON_STYLE,
  blockPayPalVenmoButton: true,
  blockPayPalCreditButton: true,
  blockPayPalPayLaterButton: true,
};
export const ADYEN_PAYPAL_CANCEL_ERROR_NAME = 'CANCEL';
